import { Button, Form, Input, message, Select } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { isMobile } from "../../extensions/design";

const VisitCntPacketItem = ({ itemMain, onClose, visitId, itemDefault }) => {
  const [form] = Form.useForm();
  const [item, setItem] = useState({visitId, saleId: itemMain?.saleId, saleProductId: itemMain?.id, qty: 1, ...itemDefault });
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);


  const getUsers = () => {
    serverFetch("user")
      .then(data => {setUsers(data.map(i => ({label: i.name, value: i.id})))})
      .catch(e => message.error(e.userMessage))
  }

  useEffect(getUsers, [])

  useEffect(() => { form.setFieldsValue(item) }, [])

  const onValuesChange = value => setItem({...item, ...value});

  const onSave = () => {
    setLoading(true);
    serverFetch("sale/use", { method: item.id ? "PUT" : "POST", bodyData: item})
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onDelete = () => {
    if (!window.confirm("Удалить?")) return;
    setLoading(true);
    serverFetch(`sale/use/${item.id}`, { method: "DELETE"})
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userName);
      })
  }

  return !isMobile ?
  <div>
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} colon={false} disabled={!item?.saleId}>
        <Form.Item label="Количество" name="qty" wrapperCol={{span: 3}}><Input /></Form.Item>
        <Form.Item label="Исполнитель" name="userId" wrapperCol={{span: 16}}><Select options={users} /></Form.Item>
        <Form.Item label=" ">
          <div className="main-content">
            <Button onClick={onDelete} disabled={loading || !item.id}>Удалить</Button>
            <Button disabled={loading || !item.qty || !item.userId} onClick={onSave}>Списать</Button>
            <Button onClick={() => onClose(false)} disabled={loading}>Отмена</Button>
          </div>
        </Form.Item>
      </Form>
  </div> : <>
    <Form form={form} layout="inline" colon={false} labelCol={{ span: 2 }} onValuesChange={onValuesChange} className="client-subitem-content">
      <Form.Item className="records-form-item-mobile" label="Кол-во" name="qty">
        <Input type="number" />
      </Form.Item>
      <Form.Item className="record-form-item-with-margin-top-mobile" label="Исполн." name="userId" >
        <Select className="records-form-item-mobile" options={users} />
      </Form.Item>
    </Form>
    <div className="visit-item-card-name-debt" style={{marginBottom: 2, marginTop: 4}}>
      <Button style={{marginRight: 8}} className="visit-body-mobile-btn" disabled={loading || !item.qty || !item.userId} onClick={onSave}>Списать</Button>
      <Button style={{marginRight: 8}} className="visit-body-mobile-btn" onClick={onDelete} disabled={loading || !item.id}>Удалить</Button>
      <Button className="visit-body-mobile-btn" onClick={() => onClose(false)}>Отмена</Button>
    </div>
  </>
}

export default VisitCntPacketItem;